import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';
import { tap } from 'rxjs/operators';

export const AuthGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  console.log('AuthGuard');

  return authService.isAuthenticated$.pipe(
    tap((loggedIn) => {
      console.log(`canActivate: ${router.url}`);
      if (!loggedIn) {
        console.log(`canActivate: ${router.url}`);

        router.navigate(['/landingpage']);
        return false;
        // this.authService.login(state.url);
      }
      return true;
    })
  );
};
